import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCvKJYwW7XK4wBVpBXUbnmZAONuKmupdy4",
  authDomain: "invexafinance-7d4bc.firebaseapp.com",
  projectId: "invexafinance-7d4bc",
  storageBucket: "invexafinance-7d4bc.firebasestorage.app",
  messagingSenderId: "791594979906",
  appId: "1:791594979906:web:092b5340dbd3deedee93db",
  measurementId: "G-PC4S3YN8VS"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;